import React from 'react';
import styled from 'styled-components/native';
import TextGeneric from '../textGeneric';
import {useTheme} from 'styled-components';
import {Theme} from '../../theme/lightTheme';
import {removeHtmlTags} from '../../utils/helpers';
import ProgressiveImage from '../progressiveImage';
import {HomeTabsProps} from '../../interfaces/components/homeTabs';
import Icon from '../icon';
import Animated from 'react-native-reanimated';
import useResponsiveDimensions from '../../utils/hooks/useResponsiveDimensions';
import {Platform} from 'react-native';

const Container = styled.TouchableOpacity<{hideImage?: boolean; isLargeScreen?: boolean; width: number}>`
  width: 100%;
  background-color: ${({theme}) => theme.home.cardBackground};
  padding: 8%;
  aspect-ratio: 1;
  ${({isLargeScreen}) =>
    isLargeScreen &&
    `
    min-width: ${200}px;
    `}
  ${({width}) =>
    width < 768 &&
    `
    min-height: 160px;
    `}
`;

const Row = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;

const ImageContainer = styled(Animated.View)`
  flex: 1;
  height: 95%;
  aspect-ratio: 1;
  margin-top: 5%;
  align-self: flex-end;
`;

const Image = styled(ProgressiveImage)`
  width: 80%;
  height: 100%;
  overflow: hidden;
  position: absolute;
`;

const Title = styled(TextGeneric)`
  font-size: ${({theme}) => theme.text.s6}px;
  color: ${({theme}) => theme.text.dark};
  flex: 1;
`;

const HomeTab = ({
  title,
  titleStyle,
  style,
  onPress,
  imageUri,
  defaultImage,
  isPrimary,
  hideImage,
}: HomeTabsProps): React.ReactElement => {
  const theme = useTheme() as Theme;
  const {width, isLargeScreen} = useResponsiveDimensions();

  return (
    <Container
      hideImage={hideImage}
      isLargeScreen={isLargeScreen}
      width={width}
      activeOpacity={0.7}
      disabled={!onPress}
      onPress={onPress}
      style={[{borderRadius: 30}, style]}>
      <Row>
        <Title semiBold numberOfLines={3} style={titleStyle}>
          {removeHtmlTags(title || '')}
        </Title>
        <Icon
          name={'navArrow'}
          size={theme.text.s1}
          color={isPrimary ? '#2823F5' : theme.text.light + 'AA'}
          stroke={isPrimary ? theme.text.light : theme.text.dark}
        />
      </Row>
      {!hideImage && (
        <ImageContainer>
          <Image
            hideLoader
            resizeMode={'contain'}
            source={{uri: imageUri}}
            defaultImage={
              defaultImage ||
              require('../../assets/images/newsCardBackground.png')
            }
          />
        </ImageContainer>
      )}
    </Container>
  );
};

export default HomeTab;
